import { TTabItem } from '@interlayer/js/components/system/TagManager/buzz/types';

export const findActiveTab = <T extends TTabItem>(items: T[], path: string, rootPage: string): null | T => {
    const active = items.find((item) => item.link === path) || null;

    const pathPageArray = path.split('/');
    pathPageArray.splice(-1);

    if (!active) {
        return pathPageArray.length > 1
            ? findActiveTab(items, pathPageArray.join('/'), rootPage)
            : items.find((item) => item.link === rootPage || item.link === '/') || null;
    }

    return active;
};
